module.exports = __webpack_public_path__ + "static/media/map1.02c161ed.png";